import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";

import EquipmentAPI from "../api/Equipment.api";
import BasicShowEdit from "../components/BasicShowEdit";
import Layout from "../components/Layout";
import { Equipment, EquipmentInput } from "../types";

export default function EquipmentShow() {
  const { id } = useParams();
  const { data: equipment } = EquipmentAPI.useDetail(id);

  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Equipments</Typography>
        </Box>

        {equipment && <EquipmentForm equipment={equipment} />}
      </Box>
    </Layout>
  );
}

function EquipmentForm({ equipment }: { equipment: Equipment }) {
  const [name, setName] = React.useState<string>(equipment.name);

  const input: EquipmentInput = {
    ...equipment,
    name,
  };

  return (
    <BasicShowEdit
      modelApiUseSave={EquipmentAPI.useSave}
      modelApiUseDelete={EquipmentAPI.useDelete}
      modelInput={input}
    >
      <TextField
        label="Name"
        value={name}
        onChange={(event) => setName(event.target.value)}
      />
    </BasicShowEdit>
  );
}
